// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__tuMxE","title":"Dashboard_title__LhGPA","cardGrid":"Dashboard_cardGrid__3CZ+a","cardLink":"Dashboard_cardLink__GJ1Y5"};